import { Directive, HostListener, ElementRef, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appCompanyNumFormat]'
})
export class CompanyNumFormatDirective {
    private specialKeys: string[] = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete'];

    constructor(private el: ElementRef, @Self() private ngControl: NgControl) {}

    private format(raw: string): string {
        const digits = raw.replace(/\D/g, '').substring(0, 10);
        return digits.length > 6
            ? digits.substring(0, 6) + '-' + digits.substring(6)
            : digits;
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (this.specialKeys.includes(event.key)) {
            return;
        }
        if (!/^\d$/.test(event.key)) {
            event.preventDefault();
            return;
        }
        const raw = this.el.nativeElement.value.replace(/\D/g, '');
        if (raw.length >= 10) {
            event.preventDefault();
        }
    }

    @HostListener('input')
    onInput() {
        const formatted = this.format(this.el.nativeElement.value);
        this.el.nativeElement.value = formatted;
        this.ngControl.control?.setValue(formatted, { emitEvent: false });
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent) {
        event.preventDefault();
        const pasted = event.clipboardData?.getData('text') ?? '';
        const formatted = this.format(pasted);
        this.el.nativeElement.value = formatted;
        this.ngControl.control?.setValue(formatted, { emitEvent: false });
    }
}
